import api from './axios'

// 메인페이지 접속 시 유저 정보 받기
// userName, childName, childId 
export const getUserInfo = async() => {
  const res = await api.get("users/main")
  return res.data
}